module.exports = __webpack_public_path__ + "static_1764244025768/img/gift_icon.229b6d65.png";